"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setVal = function (element, value) {
    element.value = value;
};
exports.getVal = function (element) {
    return element.value;
};
exports.getIntVal = function (element) {
    return parseInt(exports.getVal(element), 10);
};
exports.getFloatVal = function (element) {
    return parseFloat(exports.getVal(element));
};
